export default {
  ONBOARDING_CREATE_BANK_ACCOUNT_NUMBER_REPOSITORY:
    Symbol.for('ONBOARDING_CREATE_BANK_ACCOUNT_NUMBER_REPOSITORY'),
  ONBOARDING_CREATE_BANK_ACCOUNT_NUMBER_COMMAND:
    Symbol.for('ONBOARDING_CREATE_BANK_ACCOUNT_NUMBER_COMMAND'),
};
